import { render, staticRenderFns } from "./Asignacionesv2un.vue?vue&type=template&id=6ccd833a"
import script from "./Asignacionesv2un.vue?vue&type=script&lang=js"
export * from "./Asignacionesv2un.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports